import React from "react";

interface ContentLoaderProps {
  isLoading: boolean;
  message?: string;
  size?: "sm" | "md" | "lg";
}

const sizeClasses = {
  sm: "w-6 h-6 border-2",
  md: "w-10 h-10 border-4",
  lg: "w-14 h-14 border-4",
};

const textSizeClasses = {
  sm: "text-[10px]",
  md: "text-xs",
  lg: "text-sm",
};

/**
 * A reusable content loader overlay component.
 * Renders an absolute positioned overlay within its parent container.
 * Parent container should have `position: relative` for proper positioning.
 */
const ContentLoader: React.FC<ContentLoaderProps> = ({
  isLoading,
  message = "Loading...",
  size = "md",
}) => {
  if (!isLoading) return null;

  return (
    <div className="content-loader-overlay absolute inset-0 z-50 flex items-center justify-center">
      <div className="flex flex-col items-center gap-3">
        <div
          className={`${sizeClasses[size]} content-loader-spinner rounded-full animate-spin`}
        />
        <span
          className={`${textSizeClasses[size]} content-loader-message font-semibold tracking-wide`}
        >
          {message}
        </span>
      </div>
    </div>
  );
};

export default ContentLoader;
